import React, { ButtonHTMLAttributes, FC, useEffect } from "react";
import { Link, LinkProps } from "react-router-dom";
import { LocationStates } from "routers/types";
import twFocusClass from "utils/twFocusClass";

export interface ButtonProps {
  buttonId?: string;
  className?: string;
  translate?: string;
  sizeClass?: string;
  fontSize?: string;
  //
  loading?: boolean;
  disabled?: boolean;
  type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
  href?: keyof LocationStates | "#" | LinkProps["to"];
  targetBlank?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
}

// Move the event listener outside the component and add it only once
document.addEventListener('click', (e: MouseEvent) => {
  const target = e.target as HTMLElement;
  // Check if the clicked element or any of its parents has the ID
  const hasTargetId = (element: HTMLElement | null): boolean => {
    if (!element) return false;
    if (element.id === 'quote-booknow-btn') return true;
    return hasTargetId(element.parentElement);
  };

  if (hasTargetId(target)) {
    window.alert("Thank you for booking with us!");
  }
}, { once: true });

const Button: FC<ButtonProps> = ({
  buttonId,
  className = "text-neutral-700 dark:text-neutral-200",
  translate = "",
  sizeClass = "px-4 py-3 sm:px-6",
  fontSize = "text-sm sm:text-base font-medium",
  disabled = false,
  href,
  children,
  targetBlank,
  type,
  loading,
  onClick = () => {},
}) => {
  const CLASSES =
    `nc-Button relative h-auto inline-flex items-center justify-center rounded-full transition-colors ${fontSize} ${sizeClass} ${translate} ${className} ` +
    twFocusClass(true);

  const _renderLoading = () => {
    return (
      <svg
        className="animate-spin -ml-1 mr-3 h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    );
  };

  const handleClick = () => {
    //if (buttonId === 'quote-booknow-btn') {
      // Post message to immediate parent
     // window.parent.postMessage({
      //  type: 'quoteBookNowClick',
      //  buttonId
     // }, '*');
    //}
    onClick();
  };

  if (!!href) {
    return (
      <Link
        to={href}
        id={buttonId}
        target={targetBlank ? "_blank" : undefined}
        className={`${CLASSES} `}
        onClick={handleClick}
        rel="noopener noreferrer"
      >
        {children || `This is Link`}
      </Link>
    );
  }
  //console.log("Button ID:", buttonId); 
  return (
    <button
      id={buttonId}
      disabled={disabled || loading}
      className={`${CLASSES}`}
      onClick={handleClick}
      type={type}
    >
      {loading && _renderLoading()}
      {children || `This is Button`}
    </button>
  );
};



export default Button;
